// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"268":"fd5f49ac","306":"ae3cd89d","384":"8c03b38f"}[chunkId] + ".js";
};